module.exports = __webpack_public_path__ + "static/media/09.e0dce074.png";